import {useTranslation} from "react-i18next";
import {compareTwoDate} from "../../../utility/utils";
import {toast} from "react-toastify";
import {useContext} from "react";

const CustomDatePicker = ({context}) => {
  const {t} = useTranslation()
    const {dateValue, availableWorkingDays, available, onDateChange} = context || {};

  
    const getDate = (date) => {
        return new Date(new Date(date).getTime() - new Date().getTimezoneOffset() * 60000).toISOString().split("T")[0];
    };

    return (
        <span className="text-xl flex items-center gap-5">
            {
            t("date")
        }
            {/* <MdOutlineCalendarMonth className="ml-2 mr-1" /> */}
            <span className="text-xl cursor-pointer">
                <input type="date"
                    // style={{ display: "none" }}
                    className="w-64"
                    value={
                        dateValue ? getDate(dateValue) : getDate(available[0])
                    }
                    onChange={
                        (e) => {
                            const newDateValue = e.target.value;
                            if (!available.find((date) => compareTwoDate(date, newDateValue))) {
                                toast.warn(t("serviceSettings.dateNotAvailable"));
                                return;
                            }

                            onDateChange(new Date(newDateValue));
                        }
                    }/>
            </span>
    </span>
    );
};


export default CustomDatePicker
